var map = {
	"./addons.svg": 404,
	"./blog.svg": 405,
	"./calc.svg": 406,
	"./cdn.svg": 407,
	"./cdn24.svg": 408,
	"./cloud-network.svg": 409,
	"./combination-cloud.svg": 410,
	"./company-size.svg": 411,
	"./coprate.svg": 412,
	"./ddos.svg": 413,
	"./digital-tahavol.svg": 414,
	"./faq.svg": 415,
	"./free.svg": 416,
	"./how-to-start.svg": 417,
	"./in-xaas.svg": 418,
	"./industry.svg": 419,
	"./infra.svg": 420,
	"./left15.svg": 421,
	"./left7.svg": 422,
	"./main3.svg": 423,
	"./manage.svg": 424,
	"./manage24.svg": 425,
	"./migrate.svg": 426,
	"./organ-docs.svg": 427,
	"./organ-security.svg": 428,
	"./organ-solutions.svg": 429,
	"./organization.svg": 430,
	"./paas.svg": 431,
	"./prices.svg": 432,
	"./private-cloud.svg": 433,
	"./security.svg": 434,
	"./service-help.svg": 435,
	"./sla.svg": 436,
	"./special.svg": 437,
	"./storage.svg": 438,
	"./tech-services-for-organs.svg": 439,
	"./vpc.svg": 440,
	"./vps.svg": 441
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 230;